;(async () => {
  const { default: Swiper } = await import('../../plugins/swiper/swiper')
  import('../../plugins/swiper/swiper.scss')

  Promise.all([import(/* webpackMode: "eager" */ './availability-block.scss')]).then(() => {
    $('.widget.availability-block').each(function (i, el) {
      $(el).data('widget', new AvailabilityBlock(el, Swiper))
      $(el).data('widget').init()
    })
  })
})()

function AvailabilityBlock(el, Swiper) {
  const self = this
  self.el = $(el)
  self.parkCodes = []
  self.tabs = self.el.find('[aria-controls]')
  console.log('tabs', self.tabs)
  self.swiperInstances = {}

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('AvailabilityBlock init', self)
    }
    self.el.css('opacity', 1)

    self.initTabsSwiper()

    // Initialize the swiper for the current expanded tab
    const expandedTab = self.tabs.filter('[aria-expanded="true"]')
    if (expandedTab.length > 0) {
      const panelId = expandedTab.attr('aria-controls') || ''
      self.initTabPanelSwiper(panelId)
    }

    self.bindEvents()

    // Get all park codes from [data-park-code] elements within .js-cards-container
    self.el.find('.js-cards-container [data-park-code]').each(function (i, el) {
      const parkCode = $(el).data('park-code')
      if (parkCode) {
        // console.log('Found park code:', parkCode)
        self.parkCodes.push(parkCode)
      }
    })

    // Remove duplicates
    self.parkCodes = [...new Set(self.parkCodes)]

    // Fetch and display ratings
    fetchReviewsForParks(self.parkCodes).then(displayRatings)
  }

  async function fetchReviewsForParks(parkCodes) {
    // Check if we have parkCodes, its an array and has at least one code
    if (!Array.isArray(parkCodes) || parkCodes.length === 0) {
      console.warn('No park codes provided for fetching reviews.')
      return []
    }

    const endpoint = self.el.attr('data-api-endpoint')
    const method = self.el.attr('data-api-method')
    const gdayCaller = self.el.attr('data-api-gday-caller')

    if (!gdayCaller) {
      console.error('No Gday-Caller header provided for fetchReviewsForParks')
      return
    }

    if (!endpoint && !method) {
      console.error('No API endpoint or method defined for fetchReviewsForParks')
    }

    // Create an array of fetch requests for each park code
    const requests = parkCodes.map((parkCode) => {
      // Replace {parkCode} in the endpoint template with the actual park code
      var url = endpoint.replace('{parkCode}', parkCode)
      //url = url + "?page=1&count=999"

      return fetch(url, {
        method: method,
        headers: {
          'Gday-Caller': gdayCaller,
        },
      })
        .then((response) => {
          if (!response.ok) throw new Error(`HTTP ${response.status}`)
          return response.json().then((data) => ({ parkCode, data }))
        })
        .catch((error) => ({ parkCode, error: error.message }))
    })

    const results = await Promise.allSettled(requests)

    // Flatten to final review data array (fulfilled values)
    const reviews = results.map((result) => {
      if (result.status === 'fulfilled') {
        return result.value // { code, data } or { code, error }
      } else {
        return { code: 'unknown', error: result.reason.message || 'Unknown error' }
      }
    })

    return reviews
  }

  function displayRatings(reviews) {
    reviews.forEach(({ parkCode, data, error }) => {
      if (error) {
        console.warn(`Failed to fetch reviews for ${parkCode}: ${error}`)
        return
      }

      // Calculate average rating from individual reviews
      let displayRating = null
      let hasValidRatings = false

      if (data && data.result && Array.isArray(data.result)) {
        const reviewsWithRatings = data.result.filter(review =>
          review.ratings &&
          Array.isArray(review.ratings) &&
          review.ratings.length > 0
        )

        if (reviewsWithRatings.length > 0) {
          // Calculate average rating from all reviews
          let totalRating = 0
          let ratingCount = 0

          reviewsWithRatings.forEach(review => {
            review.ratings.forEach(rating => {
              if (rating.type === 'OverallRating' && typeof rating.value === 'number' && typeof rating.outOf === 'number') {
                // Normalize rating to a 0-5 scale
                const normalizedRating = (rating.value / rating.outOf) * 5
                totalRating += normalizedRating
                ratingCount++
              }
            })
          })

          if (ratingCount > 0) {
            const averageRating = totalRating / ratingCount
            const rating = Number.isInteger(averageRating) ? averageRating : averageRating.toFixed(1)
            displayRating = `${rating} / 5`
            hasValidRatings = true
          }
        }
      }

      // Select all matching rating elements for this park code
      const elements = document.querySelectorAll(`.js-cards-container [data-park-code="${parkCode}"] .js-rating-value`)

      if (elements.length === 0) {
        console.warn(`No .js-rating-value elements found for park code: ${parkCode}`)
      }

      elements.forEach((el) => {
        const ratingContainer = el.closest('.js-rating')

        if (hasValidRatings && displayRating) {
          // Show rating if we have valid data
          el.textContent = displayRating
          if (ratingContainer) {
            ratingContainer.classList.remove('opacity-0')
          }
        } else {
          // Hide rating container if no valid ratings
          if (ratingContainer) {
            ratingContainer.classList.add('opacity-0')
          } else {
            console.warn(`No parent .js-rating element found for ${el}`)
          }
        }
      })
    })
  }

  self.bindEvents = function () {
    self.tabs.each(function (i, el) {
      el.addEventListener('click', (e) => self.expandPanel(e.currentTarget))
    })
  }

  self.expandPanel = function (tab) {
    console.log('expandPanel', tab)
    const isExpanded = tab.getAttribute('aria-expanded') === 'true'

    // If expanded, do nothing
    if (isExpanded) {
      return
    }

    // Expand the tab
    const panelId = tab.getAttribute('aria-controls') || ''
    const panel = document.getElementById(panelId)
    tab.setAttribute('aria-expanded', String(!isExpanded))
    panel?.setAttribute('aria-hidden', String(isExpanded))

    // Initialize the swiper for the panel
    self.initTabPanelSwiper(panelId)

    // Collapse all other tabs
    self.tabs.each(function (i, el) {
      if (el !== tab) {
        el.setAttribute('aria-expanded', 'false')
        const controls = el.getAttribute('aria-controls') || ''
        const panel = document.getElementById(controls)
        panel?.setAttribute('aria-hidden', 'true')
      }
    })
  }

  self.initTabsSwiper = function () {
    const swiperEl = self.el.find('.tabs-swiper')
    self.tabsSwiper = new Swiper(swiperEl, {
      watchOverflow: true, // Prevent slides moving on drag if they do not overflow
      slidesPerView: 'auto',
    })

    // slideTo the active tab
    const activeTabIndex = self.tabs.index(self.tabs.filter('[aria-expanded="true"]'))
    if (activeTabIndex !== -1) {
      self.tabsSwiper.slideTo(activeTabIndex)
    }
  }

  self.initTabPanelSwiper = function (panelId) {
    if (!panelId) {
      console.error('Panel ID is required to initialize the swiper.')
      return
    }

    // Lazy init Swiper
    if (!self.swiperInstances[panelId]) {
      console.log('Initializing swiper for panel:', panelId)
      const panel = document.getElementById(panelId)
      const $panel = $(panel)
      const swiperEl = $panel.find('.swiper')
      console.log('swiperEl', swiperEl)

      // Find all slides in the swiper
      const slides = swiperEl.find('.swiper-slide')
      swiperEl.attr('data-slides-count', slides.length)

      // Only setup navigation if there are more than 4 slides
      let navigation = {}
      if (slides.length > 4) {
        // Buttons are not within the swiperEl, but within the parent element
        const nextEl = $panel.parent().find('.swiper-button-next')
        const prevEl = $panel.parent().find('.swiper-button-prev')

        navigation = {
          nextEl,
          prevEl,
        }

        // Show the navigation buttons
        nextEl.removeClass('!hidden')
        prevEl.removeClass('!hidden')
      }

      self.swiperInstances[panelId] = new Swiper(swiperEl, {
        loop: false,
        autoHeight: false,
        watchOverflow: true,
        slidesPerView: 'auto',
        navigation,
        pagination: {
          el: swiperEl.find('.swiper-pagination'),
          type: 'bullets',
          clickable: true,
        },
      })
    } else {
      console.log('Updating existing swiper for panel:', panelId)
      self.swiperInstances[panelId].update()
    }
  }
}
